import { Avatar } from "@mui/material";
import React from "react";
import Getusers from "../../app/auth/Getusers";

const DisplayUserInput = ({ message }) => {
  function isObject(variable) {
    return variable !== null && typeof variable === 'object';
}
  return (
    <div
      style={{
        display: "grid",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "center",
          alignContent: "center",
          background: "#eee",
          padding: "1rem",
          borderRadius: "10px",
          paddingRight: "2.5rem",
        }}
      >
        <span>
          <Avatar
            sx={{
              background: "#bb1ccc",
              width: "30px",
              height: "30px",
              fontSize: "12px",
            }}
          >
            <Getusers className="trimCls" trim={true} />
          </Avatar>
        </span>
        <span
          style={{
            fontSize: "16px",
            fontWeight: "600",
            textTransform: "capitalize",
          }}
        >
          {/* {isObject(message) ? message.text : message} */}
          {message.query ? message.query : message.text}
        </span>
      </div>
    </div>
  );
};

export default DisplayUserInput;
